import type { QueryFunctionContext } from '@tanstack/react-query';

import { gql } from '@/utilities/gql';
import { gqlClient } from '@/utilities/graphQLClient';

import type { getQueryKey } from './usePortfolioPerformanceTimeseries';

export interface QueryResponse {
  errors?: Error[];
  Portfolio: {
    performance: Record<string, number>;
  };
}

type QueryContext = QueryFunctionContext<ReturnType<typeof getQueryKey>>;

export const queryFn = async ({
  queryKey: [_key, portfolioId, { startTimestamp, endTimestamp }],
}: QueryContext) => {
  const response = await gqlClient.request(
    gql(`
      query getPortfolioPerformanceTimeseries(
        $portfolioId: String!
        $startTimestamp: Float!
        $endTimestamp: Float!
      ) {
        Portfolio(id: $portfolioId) {
          performance(
            startTimestamp: $startTimestamp
            endTimestamp: $endTimestamp
          )
        }
      }
    `),
    { portfolioId, startTimestamp, endTimestamp }
  );

  if ('Portfolio' in response) {
    const { performance } = response.Portfolio;
    return performance as Record<string, number>; // TODO: Get BE to type this on the schema
  }
};
